module.exports = __webpack_public_path__ + "static/img/1-1.7f467b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/1-1.png
// module id = Bp8w
// module chunks = 0